const project = () => import(/* webpackChunkName: "herb" */ './project');
const projedit = () => import(/* webpackChunkName: "herb" */ './projedit');
const award = () => import(/* webpackChunkName: "herb" */ './award');
const awardedit = () => import(/* webpackChunkName: "herb" */ './awardedit');

export default {
  routes: [
    //项目
    {
      path: '/herb/project',
      name: 'project',
      component: project,
      meta:{public:true}
    },
    {
      path: '/herb/projedit/:dbid?',
      name: 'projedit',
      component: projedit,
      meta:{public:true}
    },
    {
      path: '/herb/award',
      name: 'award',
      component: award,
      meta:{public:true}
    },
    {
      path: '/herb/awardedit/:dbid?',
      name: 'awardedit',
      component: awardedit,
      meta:{public:true}
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/special/herb/v1/router.js